<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$( '.footer-block__newsletter' ).appendTo( '.block-text_R8iXCE' );

$('.jdgm-all-reviews-text__text a').each(function() {

   var text = $(this).html();
   $(this).html(text.replace(' out of ', 'I/')); 

});

$(".jdgm-all-reviews-text__text a:contains(' out of ')").replaceWith("/");
